<div
  class="crowdctrl-segmented-control"
  [class.crowdctrl-segmented-control--compact]="layout === 'compact'"
>
  <ion-segment
    class="crowdctrl-segmented-control__segment"
    [scrollable]="scrollable"
    [ngModel]="innerValue"
    (ngModelChange)="onInnerModelChange($event)"
    (ionChange)="onSegmentIonChange($event)"
  >
    <ng-content></ng-content>
  </ion-segment>
</div>
